// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"93302068","311":"53faf515","454":"4f1e5a0e","604":"6bf65013","978":"27da4cb7"}[chunkId] + ".chunk.js";
};